import "./HstCalculator.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import FreeGuideSignup from "./sections/FreeGuideSignup";
import DajamsApproach from "./sections/DajamsApproach";
import Footer from "@/reusable_sections/Footer";
export default function HstCalculatorPage() {
  return <div>
      <VoltMainHeader />
      <FreeGuideSignup />
      <DajamsApproach />
      <Footer />
    </div>;
}